import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { isValid as validaData } from 'utils/date';
import { validaCpfCnpj } from 'utils/validation';
import { labelsPf, labelsPj } from 'pages/investidores/registro/informacoesPrincipais/labels';
import { investidorPfDocumentTypeDescriptions, investidorPjDocumentTypeDescriptions } from 'common/genericDescriptions';
import { validaCep, validaEmail } from 'utils/validation';

type labelsType = typeof labelsPf | typeof labelsPj;

export enum EtapaCadastro {
  InformacoesPrincipais,
  RepresentantesLegais,
  Documentos,
}

export const useValidarCampos = (labels: labelsType, etapa?: EtapaCadastro) => {
  const informacoesPrincipais = useSelector((state: RootState) => state.investidor.informacoesPrincipais);
  const endereco = useSelector((state: RootState) => state.investidor.endereco);
  const informacoesParaContato = useSelector((state: RootState) => state.investidor.informacoesParaContato);
  const informacoesBancarias = useSelector((state: RootState) => state.investidor.informacoesBancarias);
  const documentos = useSelector((state: RootState) => state.investidor.documentos);

  let camposInvalidosIP: Array<string> = [];
  if (!informacoesPrincipais.cpfCnpj || !validaCpfCnpj(informacoesPrincipais.cpfCnpj))
    camposInvalidosIP.push(labels.cpfCnpj);

  if (!informacoesPrincipais.razaoSocial) camposInvalidosIP.push(labels.razaosocial);

  if (!informacoesPrincipais.dataNascimento || !validaData(informacoesPrincipais.dataNascimento))
    camposInvalidosIP.push(labels.dataNascimento);

  if (!informacoesPrincipais.nacionalidade) camposInvalidosIP.push(labels.nacionalidade);

  if (!informacoesPrincipais.profissao) camposInvalidosIP.push(labels.profissao);

  if (informacoesPrincipais.investidorPoliticamenteExposto === undefined)
    camposInvalidosIP.push(labels.investidorPoliticamenteExposto);

  if (!informacoesPrincipais.tipo) camposInvalidosIP.push(labels.tipoInvestidor);

  if (!endereco.cep || !validaCep(endereco.cep)) camposInvalidosIP.push(labels.cep);

  if (!endereco.logradouro) camposInvalidosIP.push(labels.logradouro);

  if (!endereco.bairro) camposInvalidosIP.push(labels.bairro);

  if (!endereco.cidade) camposInvalidosIP.push(labels.cidade);

  if (!endereco.uf) camposInvalidosIP.push(labels.uf);

  if (!endereco.numero) camposInvalidosIP.push(labels.numero);

  if (informacoesParaContato.email && !validaEmail(informacoesParaContato.email)) camposInvalidosIP.push(labels.email);

  if (informacoesPrincipais.cpfCnpj.length === 11 && informacoesParaContato.telefones.length < 1) camposInvalidosIP.push(labels.telefone);

  if (etapa === EtapaCadastro.InformacoesPrincipais) return camposInvalidosIP;

  if (etapa === EtapaCadastro.RepresentantesLegais) return [];

  let camposInvalidosDocs: Array<string> = [];

  if (documentos.length === 0) {
    camposInvalidosDocs.push('Documentos');
  } else {
    documentos.forEach((doc) => {
      if (!doc.optional && !doc.file && !doc.remoteFileInfo) {
        const documentoLabel = informacoesPrincipais.isPj
          ? investidorPjDocumentTypeDescriptions[doc.type]
          : investidorPfDocumentTypeDescriptions[doc.type];
        camposInvalidosDocs.push(`${documentoLabel} - Documentos`);
      }
    });
  }

  if (etapa === EtapaCadastro.Documentos) return camposInvalidosDocs;

  return camposInvalidosIP.concat(camposInvalidosDocs);
};
